export default "__VITE_ASSET__CZV9EYpT__"